"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DRAFTS: 'drafts',
  PUBLISHED: 'published'
};
exports.default = _default;